import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.default_view.title',
        defaultMessage: 'Looks like you have no new offers today.'
    },
    description: {
        id: '_.default_view.description',
        defaultMessage: `When you have a new approved offer, you can view it here in the 'My Offers' tab. If you think this is wrong, please call us on {phoneNumber}.`
    },
    phoneNumber: {
        id: '_.default_view.phoneNumber',
        defaultMessage: '020 3778 0274'
    }
});
